import { LATEST_NEWS_ITEM } from "./catalog";

export function hasUnreadNews(lastSeenNewsAt: string | null | undefined): boolean {
  if (!LATEST_NEWS_ITEM) return false;
  if (lastSeenNewsAt == null || lastSeenNewsAt === "") return true;
  return LATEST_NEWS_ITEM.publishedAt > lastSeenNewsAt;
}

/**
 * Watermark written when the user opens the badge or a news page.
 * Must be >= the latest catalog `publishedAt`, otherwise a future-dated
 * item stays "unread" after `now` is persisted (`publishedAt > now`).
 */
export function nextLastSeenNewsAt(nowIso = new Date().toISOString()): string {
  const latestPublishedAt = LATEST_NEWS_ITEM?.publishedAt;
  if (latestPublishedAt != null && latestPublishedAt > nowIso) {
    return latestPublishedAt;
  }
  return nowIso;
}
